/* @flow */
import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Translate, I18n } from 'react-redux-i18n'
import _ from 'lodash'

import 'react-table/react-table.css'

import './style.css'
import Button from '../../components/Button'
import Checkbox from '../../components/Checkbox'
import Radio from '../../components/Radio'
import Card from '../../components/Card'
import ListItem from '../../components/ListItem'
import Preview from '../../components/Preview'
import { getShops, addToFavorite, removeFavorite } from '../../actions/shop'
import { getScenes } from '../../actions/scene'
import Header from '../../components/Header'
import { certSystems, divingServices, otherServices } from '../../configs/constants'

type ShopProps = {
  shop: Object
}
class Shop extends React.Component<ShopProps> {
  constructor(props) {
    super(props)
    this.handleRadioOnChange = this.handleRadioOnChange.bind(this)
    this.state = {
      sortByHot: true,
      selectedPhoto: null,
    }
  }

  scrollTo(e, ref) {
    e.preventDefault()
    const node = ReactDOM.findDOMNode(this.refs[ref])
    window.scrollTo(0, (node.offsetTop - 180))
  }

  handleRadioOnChange(value) {
    this.setState({
      sortByHot: value
    })
  }

  render() {
    const {
      locale, account, shops, activities, scenes, params, navigate, addToFavorite, removeFavorite, currency
    } = this.props
    const { sortByHot, selectedPhoto } = this.state
    const shop = _.find(shops, { id: params.shopId })
    let scene
    if (shop) {
      scene = _.find(scenes, (scene) => _.includes(scene.name, shop.location))
    }
    let favorite
    if (account) {
      favorite = _.find(_.map(account.favorites, (value, key) => ({key, shopId: value.shopId})), { shopId: params.shopId })
    }

    return ((shop && scene) ? <div className="shop-container">
      <div className="header">
        {shop.name[locale]}
      </div>
      <div className="sub">
        <i className="icon icon-location-marker" />
        {shop.address[locale]}
      </div>
      <div className="toolbar">
        <Button type="action"
          text={I18n.t('intro')}
          onClick={(e) => this.scrollTo(e, 'intro')} />
        <Button type="action"
          text={I18n.t('activityName')}
          onClick={(e) => {
            e.preventDefault()
            const activityNode = ReactDOM.findDOMNode(this.refs.activity)
            window.scrollTo(0, activityNode.offsetTop)
          }} />
        { account ?
           (favorite ?
            <Button type="danger"
              text={I18n.t('removeFavorite')}
              onClick={() => removeFavorite({ key: favorite.key, account })}
            /> :
            <Button type="action"
              text={I18n.t('addToFavorite')}
              onClick={() => addToFavorite({ shopId: shop.id, account })}
            />)
          : null
        }
      </div>
      <Header title={I18n.t('setup', { year: shop.setupDate })} />
      <div className="shop-photo">
        <img src={selectedPhoto || shop.photos[0]} alt={shop.name[locale]} />
        <div className="photo-list">
          {
            _.map(shop.photos, (photo, idx) => {
              const isDefaultPhoto = !selectedPhoto && idx === 0
              return <img key={'thumb-' + idx}
                className={'thumb' + (photo === selectedPhoto || isDefaultPhoto ? ' active' : '')}
                alt={shop.name[locale]}
                src={photo}
                onClick={() => this.setState({ selectedPhoto: photo })}
              />
            })
          }
        </div>
      </div>
      <div ref="intro" className="shop-desc">
        <Header title="intro" />
        <p className="shop-intro">{shop.intro[locale]}</p>
        <div className="filters">
          { shop.certSystem &&
            <Card
              header={<Translate value="certSystem" className="headline headline-light" />}>
              <ul>
              { _.map(certSystems, (system) =>
                <li key={system.id}>
                  <label>
                    <Checkbox className="caerulus" checked={shop.certSystem.indexOf(system.id) >= 0} disabled />
                    <Translate value={system.name} />
                  </label>
                </li>
              ) }
              </ul>
            </Card>
          }
          { shop.services && 
            <Card
              header={<Translate value="divingServices" className="headline headline-light" />}>
              <ul>
              { _.map(divingServices, (service) =>
                <li key={service}>
                  <label>
                    <Checkbox className="caerulus" checked={shop.services.indexOf(service) >= 0} disabled />
                    <Translate value={service} />
                  </label>
                </li>
              ) }
              </ul>
            </Card>
          }

          <Card
            header={<Translate value="otherServices" className="headline headline-light" />}>
            <ul>
            { shop.otherServices && _.map(otherServices, (service) =>
              <li key={service}>
                <label>
                  <Checkbox className="caerulus" checked={shop.otherServices.indexOf(service) >= 0} disabled />
                  <Translate value={service} />
                </label>
              </li>
            )}
            </ul>
          </Card>
        </div>
        <Header title="activityName" />
        <div ref="activity" className="options">
          <Translate value="sortType" className="headline headline-light" />
          <Radio className="caerulus"
            name="sort"
            onChange={this.handleRadioOnChange}
            checked={sortByHot}
          />
          <Translate value="hotLevel" className="headline" />
          <Radio className="caerulus"
            name="sort"
            onChange={this.handleRadioOnChange}
            checked={!sortByHot}
          />
          <Translate value="customerRecommendation" className="headline" />
        </div>
        { _.map(_.filter(activities, (activity) => activity.shopId === shop.id), (activity) => {
          const comments = _.values(activity.comments || {})
          return <ListItem key={activity.id}>
            <Preview
              imageOnLeft
              locale={locale}
              subtitle={shop.name[locale]}
              data={activity}
              options={[{
                title: 'lastFor',
                value: activity.lastFor && ((activity.lastFor || 2) + I18n.t(activity.lastForUnit))
              }, {
                title: 'charge',
                value: currency.label.toUpperCase() + ' ' + Math.ceil((activity.packages ? activity.packages[0].price : activity.price) * currency.ratio * 100) / 100
              }, {
                title: 'assemblyPlace',
                value: activity.assemblyPlace[locale]
              }]}
              footer={[{
                isRating: true,
                value: activity.rating,
                hideWhen: !activity.rating,
              }, {
                title: (comments ? comments.length : 0) + I18n.t('comments'),
                hideWhen: !comments || !comments.length
              }, {
                isButton: true,
                title: I18n.t('seeDetail'),
                onClick: (e) => {
                  navigate('/activity/' + activity.id)
                  e.preventDefault()
                  e.stopPropagation()
                }
              }]}
              onHeaderClick={(e) => {
                navigate('/shop/' + activity.shopId)
                e.preventDefault()
                e.stopPropagation()
              }}
          />
          </ListItem>
        }
      )}
      </div>
    </div> : null)
  }
}

const mapStateToProps = (state, ownProps) => ({
  locale: state.i18n.locale,
  account: state.global.user,
  activities: state.activity.all,
  scenes: state.scene.locations,
  // shop: state.shop.current,
  shops: state.shop.shops,
  params: ownProps.match.params,
  currency: state.global.currency,
})

const mapDispatchToProps = (dispatch) => ({
  navigate: (location, args) => dispatch(push(location, args)),
  getScenes: () => dispatch(getScenes()),
  getShops: () => dispatch(getShops()),
  addToFavorite: (shop) => dispatch(addToFavorite(shop)),
  removeFavorite: (payload) => dispatch(removeFavorite(payload)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Shop)


// WEBPACK FOOTER //
// ./src/containers/Shop/index.js